const baseColors = {
  gray: {
    100: '#F6F6F6',
    200: '#EEE',
    300: '#DDD',
    400: '#ccc',
    500: '#9D9D9D',
    600: '#767676',
    700: '#333',
    800: '#222',
  },
  blue: '#0B9FE9',
  lightBlue: '#F3FBFF',
  red: '#D9534F',
  green: '#29ba63',
  white: '#fff',
  black: '#080808',
};

const colors = {
  base: baseColors,
  // Semantic Colors
  primary: baseColors.blue,
  primaryHover: '#0077B2',
  secondary: baseColors.gray[800],
  secondaryHover: baseColors.gray[700],
  danger: baseColors.red,
  dangerHover: '#B2413E',
  highlight: baseColors.lightBlue,
  // WHERE ARE THESE BEING USED
  white: baseColors.white,
  black: baseColors.black,

  /*
   * sorted by components
   **/

  // Root
  text: baseColors.gray[700],
  background: baseColors.white,

  // Navbar
  navbar: baseColors.white,
  navbarHover: baseColors.blue,
  onNavbar: baseColors.gray[500],
  onNavbarHover: baseColors.blue,
  // Field
  field: baseColors.white,
  fieldHover: baseColors.gray[200],
  onField: baseColors.gray[700],
  fieldBorder: baseColors.gray[400],
  fieldBorderHover: baseColors.gray[600],
  // Table
  table: '#ececec',
  tableRow: baseColors.white,
  tableAltRow: baseColors.gray[100],
  tableActions: baseColors.gray[300],
  tableBorder: baseColors.gray[300],
  tableHeader: baseColors.blue,
  onTableHeader: baseColors.white,
  tableHover: baseColors.gray[200],
  tableActive: baseColors.gray[300],
  // Portal
  portal: baseColors.black,
  modal: baseColors.white,
  // 3rd Pane
  paneBg: baseColors.gray[100],
  utilBtn: baseColors.gray[200],
  utilBtnHover: baseColors.gray[300],
  // New Status colors
  statusRed: '#de5751',
  statusOrange: '#de8c51',
  statusYellow: '#efec68',
  statusGreen: baseColors.green,
  statusBlue: '#4ea9df',
  statusPurple: '#b94edf',
  statusDefault: baseColors.gray[200],
  statusPrimary: baseColors.blue,
  statusSuccess: '#29ba63',
  statusPending: baseColors.gray[400],
  statusError: baseColors.red,
  failPass: `linear-gradient(to right, ${baseColors.red} 50%, ${baseColors.green} 50%)`,
};

export default colors;
